import React from 'react'
import { FormattedMessage } from 'react-intl'
import ResponsiveImage from 'components/util/ResponsiveImage'
import PropTypes from 'prop-types'
import styles from './_featuresLanding.css'
import messages from './messages'
import flavorScreens from './screens'

function Feature (props) {
  const { title, description } = props
  return (
    <div className={styles.feature}>
      <h3 className={styles.featureTitle}>
        <FormattedMessage {...title} />
      </h3>
      <p className={styles.featureDescription}>
        <FormattedMessage {...description} />
      </p>
    </div>
  )
}

Feature.propTypes = {
  title: PropTypes.object,
  description: PropTypes.object,
}

function Features (props) {
  const { slug } = props.site
  const screens = flavorScreens[slug] || flavorScreens.fitness
  const featureList = ['track', 'social', 'train']
  const features = featureList.map((feature) => (
    <Feature
      key={feature}
      title={messages[feature].title}
      description={messages[feature].description}
    />
  ))
  return (
    <div className={styles.features}>
      <div className={styles.content}>
        {features}
        <div className={styles.callToAction}>
          <a href='/app'><FormattedMessage id='landingPage.features.link' defaultMessage='Check it out' /></a>
        </div>
      </div>
      <div className={styles.screen}>
        <ResponsiveImage {...screens} />
      </div>
    </div>
  )
}

Features.propTypes = {
  site: PropTypes.object,
}

export default Features



// WEBPACK FOOTER //
// ./src/components/landing/features/index.jsx